import clsx from 'clsx';

// thin wrapper so the underlying lib can be swapped (e.g. to tailwind-merge) in one place
export const cn = (...args) => clsx(...args);
